export default {
  'Teklif Formu': 'Форма Пропозиції',
  'Kayıtlı Teklifler': 'Збережені Пропозиції',
  'Kullanıcı Adı': 'Ім\'я Користувача',
  'Şifre': 'Пароль',
  'Giriş Yap': 'Увійти',
  'Çıkış Yap': 'Вийти',
  'KDV Oranı': 'Ставка ПДВ',
  'Teklif Durumu': 'Статус Пропозиції',
  'Kaydet': 'Зберегти',
  'PDF Önizleme': 'Попередній Перегляд PDF',
  'PDF\'ye Aktar': 'Експорт в PDF',
  'E-posta ile Gönder': 'Надіслати по Email',
  'Alıcı': 'Отримувач',
  'Tarih': 'Дата',
  'Genel Toplam': 'Загальна Сума',
  'Not': 'Примітка',
  'KDV': 'ПДВ',
  'Alt Toplam': 'Підсумок',
  'Açıklama': 'Опис',
  'Ürün Adı': 'Назва Продукту',
  'SUT Kodu': 'Код SUT',
  'Birim Alış Fiyatı': 'Ціна за Одиницю',
  'Sipariş Adedi': 'Кількість Замовлення',
  'Promosyon Ürün': 'Промо Продукт',
  'Toplam Adet': 'Загальна Кількість',
  'Sipariş Tutarı': 'Сума Замовлення',
  'Durum': 'Статус',
  'Kabul Edildi': 'Прийнято',
  'Reddedildi': 'Відхилено',
  'Gönderildi': 'Надіслано',
  'Taslak': 'Чернетка',
  'Yurtiçi': 'Внутрішній',
  'Yurtdışı': 'Міжнародний',
  'Sipariş Oluştur': 'Створити Замовлення',
  'Ürün Sıralaması': 'Сортування Продуктів',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'Продукти відсортовані за популярністю та рівнем важливості',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'Продукти кардіології та судинної хірургії відображаються як пріоритетні',
  'Ürün adı, açıklama veya barkod ile ara...': 'Пошук за назвою продукту, описом або штрих-кодом...',
  'Tüm Kategoriler': 'Всі Категорії',
  'Kutu görünüm': 'Вид сітки',
  'Liste görünüm': 'Вид списку',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'Не знайдено продуктів, що відповідають вашим критеріям',
  'Ürün Adı Yok': 'Немає Назви Продукту',
  'Kategori Yok': 'Немає Категорії',
  'Açıklama yok': 'Немає опису',
  'Firma Bilgilerini Doldurun': 'Заповнити Інформацію про Компанію',
  'Sepete Ekle': 'Додати в Кошик',
  'Firma Bilgileri': 'Інформація про Компанію',
  'Ülke Seçimi': 'Вибір Країни',
  'Türkiye': 'Туреччина',
  'Almanya': 'Німеччина',
  'ABD': 'США',
  'Firma Ünvanı': 'Назва Компанії',
  'Vergi Dairesi': 'Податкова Інспекція',
  'Vergi Numarası': 'ІПН',
  'Adres': 'Адреса',
  'Şehir': 'Місто',
  'Yetkili': 'Уповноважена Особа',
  'Telefon': 'Телефон',
  'Email': 'Email',
  'Bilgileri İlet': 'Надіслати Інформацію',
  'Lütfen eksik alanları doldurun': 'Будь ласка, заповніть порожні поля',
  'Firma kaydedilemedi': 'Компанію не вдалося зберегти',
  'Firma bilgileri başarıyla iletildi': 'Інформацію про компанію успішно надіслано',
  'Firma Ünvanı:': 'Назва Компанії:',
  'Yetkili Kişi:': 'Уповноважена Особа:',
  'Sepetiniz': 'Ваш Кошик',
  'Sepetiniz boş': 'Ваш кошик порожній',
  'adet': 'шт',
  'Düzenle': 'Редагувати',
  'Kaldır': 'Видалити',
  'Siparişi Tamamla': 'Завершити Замовлення',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'Будь ласка, спочатку надішліть повну інформацію про вашу компанію',
  'Sipariş başarıyla kaydedildi': 'Замовлення успішно збережено',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'Привітальне повідомлення та посилання для доступу надіслано на ваш email',
  'Link 3 gün geçerlidir': 'Посилання дійсне 3 дні',
  'Sipariş kaydedilemedi': 'Замовлення не вдалося зберегти',
  'Firma Bilgileri Gerekli': 'Потрібна Інформація про Компанію',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'Спочатку заповніть інформацію про компанію для додавання в кошик',
  'Önce Bilgileri Doldurun': 'Спочатку Заповніть Інформацію',
  'Uyarı': 'Попередження',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'Ви повинні спочатку заповнити інформацію про компанію для додавання в кошик',
  'SUT Kütüphanesi Tanımı': 'Визначення Бібліотеки SUT',
  'SUT Kodu:': 'Код SUT:',
  'Standart': 'Стандарт',
  'Açıklama (isteğe bağlı)': 'Опис (необов\'язково)',
  'Partner Ol': 'Стати Партнером',
  'Partner başvuru popup açılacak': 'Відкриється спливаюче вікно заявки партнера',
  'Dil': 'Мова',
  'E-posta': 'Email',
  'globalPartnersTitle': 'Співпраця з 30.000 Партнерів по Всьому Світу',
  'globalPartnersDesc': 'Наша широка глобальна мережа з 30.000 партнерів сприяє спільній інновації, обміну знаннями та взаємному успіху. Разом ми постійно розширюємо межі догляду за пацієнтами.',
  'bayiBasvuru': 'Форма Заявки Партнера INVAMED',
  'bayiBasvuruDesc': 'Заповніть форму нижче, щоб приєднатися до мережі партнерів INVAMED. Після розгляду вашої заявки ми зв\'яжемося з вами.',
  'applyFields': {
    'firma': 'Назва Компанії',
    'vergiNo': 'Податкова Інспекція / ІПН',
    'yetkili': 'Повне Ім\'я Уповноваженої Особи',
    'telefon': 'Телефон',
    'email': 'Email',
    'adres': 'Адреса',
    'sektor': 'Сфера Діяльності / Сектор',
    'sicil': 'Номер Реєстрації',
    'web': 'Веб-сайт'
  },
  'Şifremi Unuttum': 'Забув Пароль',
  'Demo Giriş': 'Демо Вхід',
  'Bayi Başvurusu': 'Заявка Партнера',
  'Yardım': 'Допомога',
  'Giriş yapılıyor...': 'Виконується вхід...',
  'E-posta veya şifre hatalı': 'Невірний email або пароль',
  'Şifre sıfırlama e-postası gönderildi': 'Email для скидання пароля надіслано',
  'E-posta gönderilemedi': 'Email не вдалося надіслати',
  'Vergi Dairesi / Vergi No': 'Податкова Інспекція / ІПН',
  'Yetkili Adı Soyadı': 'Повне Ім\'я Уповноваженої Особи',
  'Faaliyet Alanı / Sektör': 'Сфера Діяльності / Сектор',
  'Ticaret Sicil No': 'Номер Реєстрації',
  'Web Sitesi': 'Веб-сайт',
  'Temel Bilgiler': 'Основна Інформація',
  'Ek Bilgiler': 'Додаткова Інформація',
  'Başvuru Gönder': 'Надіслати Заявку',
  'Başvuru gönderiliyor...': 'Надсилання заявки...',
  'Başvuru başarıyla gönderildi': 'Заявку успішно надіслано',
  'Başvuru gönderilemedi': 'Заявку не вдалося надіслати',
  'Sözleşme şartlarını kabul ediyorum': 'Я приймаю умови договору',
  'Dosya Yükle': 'Завантажити Файл',
  'Dosya seçilmedi': 'Файл не вибрано',
  'Dosya yüklendi': 'Файл успішно завантажено',
  'Dosya yüklenemedi': 'Файл не вдалося завантажити',
  'Tamamla': 'Завершити',
  'Geri': 'Назад',
  'İleri': 'Далі',
  'Kapat': 'Закрити',
  'Yardım İçeriği': 'Зміст Допомоги',
  'dil': 'Мова',
  'Üye Ol': 'Зареєструватися',
  'Üye Değil Misiniz?': 'Не Зареєстровані?',
  'Şimdi Üye Ol': 'Зареєструватися Зараз',
  'Misafir Kullanıcı': 'Гість Користувач',
  'Hızlı Sipariş': 'Швидке Замовлення',
  'Misafir Olarak Sipariş Verin': 'Зробіть Замовлення як Гість',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'Швидко виберіть ваші продукти та створіть замовлення без входу',
  'Giriş yapmadan sipariş oluşturun': 'Створіть замовлення без входу',
  'Anında Erişim': 'Миттєвий Доступ',
  'Tüm ürünlere anında erişim': 'Миттєвий доступ до всіх продуктів',
  'Güvenli İşlem': 'Безпечна Транзакція',
  'SSL korumalı güvenli sipariş': 'Безпечне замовлення з захистом SSL',
  'Misafir Olarak Sipariş Oluştur': 'Створіть Замовлення як Гість',
  'İpucu:': 'Порада:',
  'Daha fazla özellik için üye olun': 'Зареєструйтеся для більше функцій',
  'Ücretsiz': 'Безкоштовно',
  'Hızlı': 'Швидко',
  'Güvenli': 'Безпечно',
  'bayilikSozlesme': 'Я прочитав та приймаю умови та договір партнерства.',
  'geri': 'Назад',
  'basvuruGonder': 'Надіслати Заявку',
  'ileri': 'Далі',
  'sozlesmeGonderildi': 'Договір Надіслано на Ваш Email!',
  'sozlesmeDesc': 'Будь ласка, завантажте Договір Партнерства INVAMED та необхідні документи, надіслані на ваш email.',
  'tamamla': 'Завершити Заявку',
  'basvuruAlindi': 'Ваша Заявка Прийнята!',
  'basvuruAlindiDesc': 'Команда INVAMED розгляне вашу заявку та зв\'яжеться з вами найближчим часом.',
  'Başvuru Durumu': 'Статус заявки',
  'Başvurunuz onay sürecindedir': 'Ваша заявка розглядається',
  'sifreSifirla': 'Скидання Пароля',
  'sifreSifirlaDesc': 'Введіть ваш зареєстрований email, ми надішлемо інструкції для скидання пароля.',
  'gonder': 'Надіслати',
  'talimatGonderildi': 'Інструкції Надіслано',
  'sentDesc': 'Інструкції для скидання пароля надіслано на <b>{email}</b>. Будь ласка, перевірте ваш email.',
  'helpTitle': 'Як Я Можу Увійти?',
  'helpList': [
    'Для входу в панель партнера INVAMED введіть ваш зареєстрований email та пароль.',
    'Для входу з демо користувачем:',
    'Якщо ви забули пароль, ви можете запросити скидання через посилання "Забув Пароль".',
    'Якщо у вас проблеми з входом, переконайтеся, що ви правильно ввели email та пароль. Якщо проблема продовжується, зв\'яжіться з нашою командою підтримки.'
  ],
  'partnerlikSozlesmeTitle': 'Договір та Умови Партнерства INVAMED',
  'partnerlikSozlesmeText': `1. ЗАГАЛЬНІ ПОЛОЖЕННЯ

Цей договір укладено між INVAMED (далі "Компанія") та кандидатом у партнери (далі "Партнер") для співпраці в галузі продажу медичного обладнання та приладів.

2. УМОВИ ПАРТНЕРСТВА

2.1. Партнер повинен мати юридичні повноваження для продажу медичного обладнання.
2.2. Партнер повинен бути організацією, що працює в сфері охорони здоров'я.
2.3. Партнер повинен мати необхідні ліцензії та сертифікати.
2.4. Партнер повинен бути фінансово надійним.

3. ЗОБОВ'ЯЗАННЯ СТОРІН

Зобов'язання Компанії:
3.1. Надавати якісну продукцію та послуги
3.2. Надавати технічну підтримку
3.3. Проводити навчання та інформування
3.4. Бути прозорими в ціноутворенні

Зобов'язання Партнера:
3.1. Зберігати продукцію в належних умовах
3.2. Надавати якісне обслуговування клієнтів
3.3. Дотримуватися правових норм
3.4. Захищати бренд Компанії

4. ЦІНОУТВОРЕННЯ ТА ОПЛАТА

4.1. Ціни встановлюються Компанією
4.2. Партнер зобов'язаний дотримуватися встановлених цін
4.3. Умови оплати визначаються окремо
4.4. Комісійні ставки можуть змінюватися залежно від результатів

5. КОНФІДЕНЦІЙНІСТЬ ТА БЕЗПЕКА

5.1. Сторони зобов'язані захищати конфіденційну інформацію один одного
5.2. Інформація про клієнтів повинна зберігатися в таємниці
5.3. Повинні дотримуватися стандартів безпеки даних

6. ТРИВАЛІСТЬ ТА РОЗІРВАННЯ ДОГОВОРУ

6.1. Цей договір діє протягом 1 року
6.2. Може бути продовжений за взаємною згодою
6.3. Може бути розірваний з попередженням за 30 днів
6.4. Може бути розірваний негайно у випадку серйозного порушення

7. ВИРІШЕННЯ СПОРІВ

7.1. Спори спочатку намагаються вирішити через переговори
7.2. У випадках, що не можуть бути вирішені, компетентні суди Турецької Республіки

8. ДІЯ

Цей договір прочитано, зрозуміло та прийнято сторонами. Я заявляю, що приймаю всі положення цього договору та буду виконувати свої зобов'язання.`,
  'partnerlikSozlesmeOnay': 'Я прочитав, зрозумів та прийняв Договір та Умови Партнерства INVAMED вище. Я заявляю, що приймаю всі положення цього договору та буду виконувати свої зобов\'язання.',
  'sozlesmeyiGoruntule': 'Переглянути Договір',
  'sozlesmeyiKapat': 'Закрити',
  'Ürün': 'Продукт',
  'Ürün eklemek için ürün listesinden seçim yapın': 'Виберіть зі списку продуктів для додавання продукту',
  'Etiketler': 'Мітки',
  'Öncelikli': 'Пріоритетний',
  'Ülke Seçiniz': 'Виберіть Країну',
  'Firma / Sağlık Profesyoneli': 'Компанія / Професіонал Охорони Здоров\'я',
  'Şehir Seçiniz': 'Виберіть Місто',
  'Yetkili Kişi': 'Уповноважена Особа',
  'UDI Kodu': 'Код UDI',
  'Teklif başarıyla kaydedildi!': 'Пропозицію успішно збережено!',
  'Aynı teklif zaten kayıtlı!': 'Така пропозиція вже збережена!',
  'Kullanıcı adı veya şifre hatalı!': 'Невірне ім\'я користувача або пароль!',
  'Teklif No': 'Номер Пропозиції',
  'Teklifler': 'Пропозиції',
  'Yedeklenecek teklif yok!': 'Немає пропозицій для резервного копіювання!',
  'Yedek dosyası indirildi.': 'Резервний файл завантажено.',
  'Yedek başarıyla yüklendi.': 'Резервну копію успішно завантажено.',
  'Geçersiz veya bozuk dosya!': 'Недійсний або пошкоджений файл!',
  'Yedekle (JSON)': 'Резервне копіювання (JSON)',
  'Geri Yükle': 'Відновити',
  'Kayıtlı teklif yok.': 'Немає збережених пропозицій.',
  'E-posta Durumu': 'Статус Email',
  'İşlemler': 'Операції',
  'E-posta ile gönderildi': 'Надіслано по email',
  'E-posta gönderilmedi': 'Email не надіслано',
  'Görüntüle': 'Переглянути',
  'Sil': 'Видалити',
  'Gönderildi': 'Надіслано',
  'Gönderilmedi': 'Не надіслано',
  'Teklif ID bulunamadı! Lütfen tekrar deneyin.': 'ID Пропозиції не знайдено! Будь ласка, спробуйте ще раз.',
  'Lütfen partner seçiniz.': 'Будь ласка, виберіть партнера.',
  'Lütfen teslimat tarihi belirtiniz.': 'Будь ласка, вкажіть дату доставки.',
  'Proforma başarıyla oluşturuldu!': 'Проформа успішно створена!',
  'Proforma oluşturuldu ancak ürün eklenemedi. Detaylar için konsolu kontrol edin.': 'Проформа створена, але продукт не вдалося додати. Перевірте консоль для деталей.',
  'Link başarıyla silindi': 'Посилання успішно видалено',
  'Link kopyalandı!': 'Посилання скопійовано!',
  'Ödeme durumu başarıyla güncellendi!': 'Статус оплати успішно оновлено!',
  'dosyası okunamadı!': 'файл не вдалося прочитати!',
  'Tüm dosyalar için SUT kodu ve fiyat kolonlarını seçmelisiniz!': 'Ви повинні вибрати колонки коду SUT та ціни для всіх файлів!',
  'Yüklenecek geçerli satır bulunamadı! Lütfen dosya(lar)da SUT kodu ve fiyatı dolu satır olduğundan emin olun.': 'Не знайдено дійсних рядків для завантаження! Переконайтеся, що у файлі(ах) є рядки з заповненим кодом SUT та ціною.',
  'Yükleme sırasında hata oluştu!': 'Сталася помилка під час завантаження!',
  'Otomatik etiket ekleme başarısız!': 'Автоматичне додавання міток не вдалося!',
  'Etiketler başarıyla güncellendi!': 'Мітки успішно оновлено!',
  'Etiketler güncellenirken hata oluştu!': 'Сталася помилка під час оновлення міток!',
  'Resim başarıyla yüklendi!': 'Зображення успішно завантажено!',
  'Resim yüklendi ama ürün güncellenemedi!': 'Зображення завантажено, але продукт не вдалося оновити!',
  'Resim yüklenirken hata oluştu!': 'Сталася помилка під час завантаження зображення!',
  'Ürün başarıyla güncellendi!': 'Продукт успішно оновлено!',
  'Ürün güncellenirken hata oluştu!': 'Сталася помилка під час оновлення продукту!',
  'Hata:': 'Помилка:',
  'Güncelleme hatası:': 'Помилка оновлення:',
  'Alanlar yüklendi:': 'Поля завантажено:',
  'alan': 'поле',
  'Connect Free!': 'Підключіться безкоштовно!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'Відкрийте наші найпопулярніші продукти',
  'Tüm Kategoriler': 'Всі категорії',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 товарів показано (Всього: 8000+)',
  'Tüm Ürünleri Gör →': 'Переглянути всі товари →',
  'Detaylar': 'Деталі',
  'Sipariş Ver': 'Замовити',
  'Giriş Yap': 'Увійти',
  'Hesabınıza giriş yapın': 'Увійдіть до свого облікового запису',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'Цей сайт захищений reCAPTCHA і застосовуються Політика конфіденційності та Умови використання Google.',
  'Ürün Kataloğumuz': 'Наш каталог продуктів',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'Ми пропонуємо понад 8000 продуктів',
  '1,3B': '1,3К',
  'Partner': 'Партнер',
  '8,4M': '8,4М',
  'Toplam Üretim': 'Загальне виробництво',
  '23': '23',
  'Branş': 'Філія',
  '27,5B': '27,5К',
  'Toplam Sipariş': 'Загальні замовлення',
  'Connect Now': 'Підключитися зараз',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'Зареєструйтеся безкоштовно, щоб отримати доступ до всієї інформації в одному місці.',
  'Ürün Detayları': 'Деталі продукту',
  'Kapat': 'Закрити',
  'Yükleniyor...': 'Завантаження...',
  'Hata': 'Помилка',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} товарів показано (Всього: 8000+)',
  'Şehir Seçimi': 'Вибір міста',
  'Firma / Sağlık Profesyoneli': 'Компанія / Медичний фахівець',
  'Yetkili Kişi': 'Уповноважена особа',
  'Telefon': 'Телефон',
  'E-posta': 'Email',
  'Temel Bilgiler': 'Основна інформація',
  'Ek Bilgiler': 'Додаткова інформація',
  'Faaliyet Alanı / Sektör': 'Сфера діяльності / Сектор',
  'Ülke Seçimi': 'Вибір країни',
  'Ülke adı veya kodu ara...': 'Пошук назви або коду країни...',
  'region.Avrupa': 'Європа',
  'region.Amerika': 'Америка',
  'region.Asya': 'Азія',
  'region.Afrika': 'Африка',
  'region.Okyanusya': 'Океанія',
  'region.Diğer': 'Інше',
  'country.TR': 'Туреччина',
  'country.US': 'Сполучені Штати',
  'country.DE': 'Німеччина',
  'country.FR': 'Франція',
  'country.GB': 'Великобританія',
  'country.IT': 'Італія',
  'country.ES': 'Іспанія',
  'country.RU': 'Росія',
  'country.CN': 'Китай',
  'country.JP': 'Японія',
  'country.KR': 'Південна Корея',
  'country.IN': 'Індія',
  'country.BR': 'Бразилія',
  'country.CA': 'Канада',
  'country.AU': 'Австралія',
  'Ticaret Sicil No': 'Номер торгового реєстру',
};
